import styled from 'styled-components';
import { rgba, darken } from 'polished';

const transitionDuration = '300ms';

export const Container = styled.div`
	position: relative;
	transition: background-color ${transitionDuration} ease;
	background-color: ${({ theme, ...props }) => {
	const opacity = props.isOpen ? 0.75 : 0;
	return rgba(theme['black'], opacity);
}};
	overflow: hidden;
	pointer-events: ${(props) => props.isOpen ? 'all' : 'none'};
`;

export const Overlay = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	pointer-events: ${(props) => props.isOpen ? 'all' : 'none'};
`;

export const MenuContainer = styled.div`
	display: grid;
	grid-template-rows: auto 1fr;
	transition: transform ${transitionDuration} cubic-bezier(0.86, 0.01, 0.77, 0.78);
	transform: ${(props) => props.isOpen ? `translateX(0)` : 'translateX(calc(-100% - 9px))'};
	background-color: ${({ theme }) => darken(0.02, theme['midnight-lighten-5'])};
	max-width: 40rem;
	height: 100vh;
	box-shadow: 3px 0px 6px 0px ${({ theme }) => rgba(theme['black'], 0.5)};
`;

export const Header = styled.header`
	padding: 1.5rem 1.5rem 0;

	h3 {
		margin-bottom: 0.75rem;
		font-weight: 700;
	}
`;

export const FiltersContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 1.25rem;
	padding-top: 1rem;

	& > div {
		display: flex;

		label {
			margin-right: 2rem;
			margin-bottom: 0;
			font-weight: 700;
		}
	}
`;

export const CheckboxLabel = styled.span`
	margin-left: 0.5rem;
`;

export const Prompt = styled.div`
	display: grid;
	grid-template-columns: auto 1fr auto;
	align-items: start;
	gap: 0.75rem;
	margin-top: 0.75rem;
	margin-bottom: 1rem;
	border: 1px solid ${({ theme }) => theme['midnight-lighten-15']};
	border-radius: 0.25rem;
	background-color: ${({ theme }) => theme['midnight-lighten-5']};
	padding: 0.875rem 1rem;
`;

export const PromptBody = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.5rem;
`;

export const PromptTitle = styled.span`
	font-weight: 700;
	line-height: 1.25;
`;

export const PromptText = styled.p`
	margin: 0;
	color: ${({ theme }) => theme['silver-base']};
	font-size: 0.875rem;
	line-height: 1.35;
`;

export const PromptDismiss = styled.button`
	border: 0;
	background: none;
	cursor: pointer;
	padding: 0.25rem;
	line-height: 1;

	&:hover path {
		fill: ${({ theme }) => theme['white']};
	}
`;
